import { CrfRegistroEsin204Importacao } from '@app/api/crf/CrtRegistroEsin204';
import { listCrfRegistroEsin204Fechamento } from '@app/state/atom';
import { FormSelect, InlineEditColumnProps, Table } from '@digital/ui';
import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { Collapse } from 'antd';
import { formatCurrencyBr, formatCurrencyUS } from '@app/helpers/numbers';
import { compareNumber, compareText, compareTypeNumber } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { getAllTipoExecutadoAnoMesOptions, Tipo } from '@app/api/status';

interface TabelaRegistroImportacaoProps {

}

const { Panel } = Collapse;
const TabelaRegistroImportacao = (props: TabelaRegistroImportacaoProps) => {
    const [listRegistroEsinResult, setlistRegistroEsinResult] = useRecoilState(listCrfRegistroEsin204Fechamento);
    const [totalizador, setTotalizador] = useState({ totalValorReal: 0, totalValorDorlar: 0 });
    const [allTipoExecutadoAnoMesOptions, setAllTipoExecutadoAnoMesOptions] = useState<Tipo[]>();
    const larguraColuna = 200;

    useEffect(() => {
        let totalValorReal = 0;
        let totalValorDolar = 0;
        listRegistroEsinResult.map((registro) => {
            totalValorReal += registro.importacaoValorMovto;
            totalValorDolar += registro.importacaoValorMovtoEmDolar;
        });

        setTotalizador({ totalValorReal: totalValorReal, totalValorDorlar: totalValorDolar });
    }, [listRegistroEsinResult]);

    useEffect(() => {
        getAllTipoExecutadoAnoMesOptions().then((data) => {
            setAllTipoExecutadoAnoMesOptions(data)
        })
    }, []);

    const tratarValorBool = (value: boolean) => value == true ? 'SIM' : 'NÃO';

    const getAllColluns = (): InlineEditColumnProps<CrfRegistroEsin204Importacao>[] => {
        const coluns: InlineEditColumnProps<CrfRegistroEsin204Importacao>[] = [];

        coluns.push(
            {
                title: 'Conta Ctbl',
                dataIndex: 'importacaoContaCtbl',
                sorter: (a, b) => {
                    return compareText(a.importacaoContaCtbl, b.importacaoContaCtbl)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoContaCtbl', 'Pesquisar por Conta Ctbl')
            },
            {
                title: 'Descrição da conta',
                dataIndex: 'importacaoDescricaoConta',
                sorter: (a, b) => {
                    return compareText(a.importacaoDescricaoConta, b.importacaoDescricaoConta)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDescricaoConta', 'Pesquisar por Descrição da conta')
            },
            {
                title: 'Processo',
                dataIndex: 'importacaoProcesso',
                sorter: (a, b) => {
                    return compareText(a.importacaoProcesso, b.importacaoProcesso)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoProcesso', 'Pesquisar')
            },
            {
                title: 'Referencia',
                dataIndex: 'importacaoReferencia',
                sorter: (a, b) => {
                    return compareText(a.importacaoReferencia, b.importacaoReferencia)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoReferencia', 'Pesquisar')
            },
            {
                title: 'Item e descrição',
                dataIndex: 'importacaoHistorico',
                sorter: (a, b) => {
                    return compareText(a.importacaoHistorico, b.importacaoHistorico)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoHistorico', 'Pesquisar')
            },
            {
                title: 'Data Movto',
                dataIndex: 'importacaoDataMovto',
                sorter: (a, b) => {
                    return compareText(a.importacaoDataMovto, b.importacaoDataMovto)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDataMovto', 'Pesquisar')
            },
            {
                title: 'D/C',
                dataIndex: 'importacaoDc',
                sorter: (a, b) => {
                    return compareText(a.importacaoDc, b.importacaoDc)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDc', 'Pesquisar')
            },
            {
                title: 'Quantidade',
                dataIndex: 'importacaoQuantidade',
                sorter: (a, b) => {
                    return compareTypeNumber(a.importacaoQuantidade, b.importacaoQuantidade)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDc', 'Pesquisar')
            },
            {
                title: 'VLR TOTAL',
                align: 'center',
                width: larguraColuna,
                children: [{
                    title: `${formatCurrencyBr(totalizador.totalValorReal)}`,
                    align: 'center',
                    render: (text: any, record: CrfRegistroEsin204Importacao, index: number) => {
                        return [<> {formatCurrencyBr(record.importacaoValorMovto)}</>]
                    }
                }]
            },
            {
                title: 'Vl. Mat. Dolar',
                align: 'center',
                width: larguraColuna,
                children: [{
                    title: `${formatCurrencyUS(totalizador.totalValorDorlar)}`,
                    align: 'center',
                    render: (text: any, record: CrfRegistroEsin204Importacao, index: number) => {
                        return [<> {formatCurrencyUS(record.importacaoValorMovtoEmDolar)}</>]
                    }
                }]

            },
            {
                title: 'Documento',
                dataIndex: 'importacaoDocumento',
                sorter: (a, b) => {
                    return compareText(a.importacaoDocumento, b.importacaoDocumento)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDocumento', 'Pesquisar')

            },
            {
                title: 'Usuário',
                dataIndex: 'importacaoUsuario',
                sorter: (a, b) => {
                    return compareText(a.importacaoUsuario, b.importacaoUsuario)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoUsuario', 'Pesquisar')
            },
            {
                title: 'Ord manut',
                dataIndex: 'importacaoOrdManut',
                sorter: (a, b) => {
                    return compareText(a.importacaoOrdManut, b.importacaoOrdManut)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrdManut', 'Pesquisar')
            },
            {
                title: 'Tipo manut',
                dataIndex: 'importacaoTipoManut',
                sorter: (a, b) => {
                    return compareText(a.importacaoTipoManut, b.importacaoTipoManut)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrdManut', 'Pesquisar')
            },
            {
                title: 'Tipo de Tipo manut',
                dataIndex: 'importacaoTipoDeTipoManut',
                sorter: (a, b) => {
                    return compareText(a.importacaoTipoDeTipoManut, b.importacaoTipoDeTipoManut)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoTipoDeTipoManut', 'Pesquisar')
            },
            {
                title: 'Cod. eqpto',
                dataIndex: 'importacaoCodEqpto',
                sorter: (a, b) => {
                    return compareText(a.importacaoCodEqpto, b.importacaoCodEqpto)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoCodEqpto', 'Pesquisar')
            },
            {
                title: 'TAG',
                dataIndex: 'importacaoTAg',
                sorter: (a, b) => {
                    return compareText(a.importacaoTAg, b.importacaoTAg)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoTAg', 'Pesquisar')
            },
            {
                title: 'Conta origem',
                dataIndex: 'importacaoContaOrigem',
                sorter: (a, b) => {
                    return compareText(a.importacaoContaOrigem, b.importacaoContaOrigem)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoContaOrigem', 'Pesquisar')
            },
            {
                title: 'Conta despesa OP',
                dataIndex: 'importacaoContaDespesaOp',
                sorter: (a, b) => {
                    return compareText(a.importacaoContaDespesaOp, b.importacaoContaDespesaOp)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoContaDespesaOp', 'Pesquisar')
            },
            
            {
                title: 'FORNECEDOR',
                children: [
                    {
                        title: 'NÚMERO',
                        dataIndex: 'fornecedorNumero',
                        width: larguraColuna,
                        sorter: (a, b) => compareNumber(a ? a.fornecedorNumero : 0, b ? b.fornecedorNumero : 0),
                        ...mountFormFilterDropDown('fornecedorNumero', 'Pesquisar')
                    },
                    {
                        title: 'NOME',
                        dataIndex: 'fornecedorNome',
                        width: larguraColuna,
                        sorter: (a, b) => compareText(a.fornecedorNome, b.fornecedorNome),
                        render(text, record, index) {
                            return <>{record.fornecedorNome ? record.fornecedorNome.substring(0, 20) : ''} </>;
                        },
                        ...mountFormFilterDropDown('fornecedorNome', 'Pesquisar')
                    },
                    {
                        title: 'MRN',
                        dataIndex: 'fornecedorMrn',
                        width: larguraColuna,
                        render(text, record, index) {

                            return <>
                                <FormSelect
                                    name={`fornecedorMrn${record.id}`}
                                    placeholder="Selecione uma opção"
                                    options={allTipoExecutadoAnoMesOptions}
                                    value={record.fornecedorMrn}
                                    disabled={true}
                                    // onChange={value => {
                                    //     atualizarFornecedorMrn(value as string, record);
                                    // }}
                                />
                            </>;
                        }
                    },
                ]
            },

            {
                title: 'Item',
                dataIndex: 'importacaoItem',
                sorter: (a, b) => {
                    return compareText(a.importacaoItem, b.importacaoItem)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoItem', 'Pesquisar')
            },
            {
                title: 'Ordem Compra',
                dataIndex: 'importacaoNumOc',
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoNumOc', 'Pesquisar'),
            },
            {
                title: 'Data conf. OC',
                dataIndex: 'importacaoDataConfOC',
                sorter: (a, b) => {
                    return compareText(a.importacaoDataConfOC, b.importacaoDataConfOC)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDataConfOC', 'Pesquisar')
            },
            {
                title: 'Origem data OC',
                dataIndex: 'importacaoOrigemDataOc',
                sorter: (a, b) => {
                    return compareText(a.importacaoOrigemDataOc, b.importacaoOrigemDataOc)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrigemDataOc', 'Pesquisar')
            },
            {
                title: 'Requisitante OC',
                dataIndex: 'importacaoRequisitanteOc',
                sorter: (a, b) => {
                    return compareText(a.importacaoRequisitanteOc, b.importacaoRequisitanteOc)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoRequisitanteOc', 'Pesquisar')
            },
            {
                title: 'Ordem invest.',
                dataIndex: 'importacaoOrdemInvest',
                sorter: (a, b) => {
                    return compareText(a.importacaoOrdemInvest, b.importacaoOrdemInvest)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrdemInvest', 'Pesquisar')
            },
            {
                title: 'Divisão (Área)',
                dataIndex: 'importacaoDivisaoArea',
                sorter: (a, b) => {
                    return compareText(a.importacaoDivisaoArea, b.importacaoDivisaoArea)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDivisaoArea', 'Pesquisar')
            },
            {
                title: 'Descrição da divisão (Área)',
                dataIndex: 'importacaoDescricaoDaDivisaoArea',
                sorter: (a, b) => {
                    return compareText(a.importacaoDescricaoDaDivisaoArea, b.importacaoDescricaoDaDivisaoArea)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDescricaoDaDivisaoArea', 'Pesquisar')
            },
            {
                title: 'Contrato/PCs',
                dataIndex: 'importacaoNumContrato',
                sorter: (a, b) => {
                    return compareTypeNumber(a.importacaoNumContrato, b.importacaoNumContrato)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoNumContrato', 'Pesquisar'),

            },
            {
                title: 'Num pedido',
                dataIndex: 'importacaoNumPedido',
                sorter: (a, b) => {
                    return compareText(a.importacaoNumPedido, b.importacaoNumPedido)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoNumPedido', 'Pesquisar')
            },
            {
                title: 'Observação',
                dataIndex: 'importacaoObservacao',
                sorter: (a, b) => {
                    return compareText(a.importacaoObservacao, b.importacaoObservacao)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoObservacao', 'Pesquisar')
            },
            {
                title: 'Aprop',
                dataIndex: 'importacaoTipoAprop',
                sorter: (a, b) => {
                    return compareText(a.importacaoTipoAprop, b.importacaoTipoAprop)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoTipoAprop', 'Pesquisar')
            },
            {
                title: 'VRP',
                dataIndex: 'telaVerbaRemanescenteProvisao',
                width: larguraColuna,
                align: 'center',
                ...mountFormFilterDropDown('telaVerbaRemanescenteProvisao', 'Pesquisar'),
                render(text, record, index) {
                    return [<> {tratarValorBool(record.telaVerbaRemanescenteProvisao)} </>]
                },

            },
            {
                title: 'DESCONSIDERAR EXECUTADO',
                dataIndex: 'telaDesconsiderarAno',
                width: larguraColuna,
                align: 'center',
                ...mountFormFilterDropDown('telaDesconsiderarAno', 'Pesquisar'),
                render(text, record, index) {

                    return [<> {tratarValorBool(record.telaDesconsiderarAno)} </>]
                },
            },
            {
                title: 'MOTIVO',
                dataIndex: 'telaDesconsiderarAnoMotivo',
                width: larguraColuna,
            }
        )
        return coluns;
    }

    return (
        <Table
            columns={getAllColluns()}
            dataSource={listRegistroEsinResult}
            pagination={{ pageSize: 5 }}
            scroll={{ x: (larguraColuna * 35) }}
        />
    )
}

export default TabelaRegistroImportacao;